module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (false) ? _c('div', {
    staticClass: "jin-list",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "jin-list__wrap"
  }, [_c('div', {
    ref: "box",
    staticClass: "jin-list__box"
  }, [_c('div', {
    staticClass: "jin-list__h"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    ref: "navWrap",
    staticClass: "jin-list-nav"
  }, _vm._l((_vm.list), function(item, key) {
    return _c('li', {
      key: key,
      ref: ("nav-" + key),
      refInFor: true,
      staticClass: "jin-list-nav__item",
      class: {
        'is-active': _vm.type === key
      },
      on: {
        "click": function($event) {
          return _vm.getDatas(key)
        }
      }
    }, [_vm._v(_vm._s(_vm.getNavTitle(key)))])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "jin-list__more",
    attrs: {
      "href": ("https://v.jin10.com/list.html?cate=" + _vm.id),
      "target": "_blank"
    }
  }, [_vm._v("查看更多")])]), _vm._v(" "), _c('div', {
    staticClass: "jin-list__b"
  }, [_c('ul', {
    staticClass: "jin-news"
  }, _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      key: index,
      staticClass: "jin-news__item"
    }, [(data) ? [_c('div', {
      staticClass: "jin-news__h"
    }, [_c('img', {
      attrs: {
        "src": data.thumb,
        "alt": data.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "jin-news-mask"
    }, [_c('div', {
      staticClass: "jin-news-mask__box"
    }, [_c('a', {
      staticClass: "jin-news__btn",
      attrs: {
        "href": ("https://v.jin10.com/details.html?id=" + (data.id)),
        "target": "_blank"
      }
    }, [_c('icon', {
      attrs: {
        "type": "play"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "jin-news__btn"
    }, [_c('icon', {
      attrs: {
        "type": "share"
      }
    }), _vm._v(" "), _c('share-button', {
      attrs: {
        "url": ("https://v.jin10.com/details.html?id=" + (data.id)),
        "title": data.title
      }
    })], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "jin-news__b"
    }, [_c('a', {
      attrs: {
        "href": ("https://v.jin10.com/details.html?id=" + (data.id)),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "jin-news__info"
    }, [_c('span', [_vm._v(_vm._s(data.title_sub))])]), _vm._v(" "), _c('h3', {
      staticClass: "jin-news__title",
      class: {
        'is-none-subtitle': !data.title_sub
      }
    }, [_vm._v(_vm._s(data.title))])])])] : _vm._e()], 2)
  }), 0)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "jin-list__title"
  }, [_c('span', [_vm._v("相关推荐")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-236b17ee","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/Content/src/list.vue
// module id = Wpil
// module chunks = 2 3 4 6 7 8 9